// src/components/mobile/AddProjectModalMobile.jsx
import React, { useContext, useState, useEffect } from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  TextField,
  Autocomplete,
  Chip,
  Button,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LanguageContext } from "../context/LanguageContext";

export default function AddProjectModalMobile({
  open,
  onClose,
  companyUsers = [],
  handleCreateProject,
}) {
  const { translate } = useContext(LanguageContext);
  const [name, setName] = useState("");
  const [members, setMembers] = useState([]);
  const [saving, setSaving] = useState(false);

  // Reset fields à l’ouverture/fermeture
  useEffect(() => {
    if (open) {
      setName("");
      setMembers([]);
      setSaving(false);
    }
  }, [open]);

  const onConfirm = async () => {
    if (!name.trim()) return;
    setSaving(true);
    await handleCreateProject(name.trim(), members);
    setSaving(false);
    onClose();
  };

  return (
    <Dialog fullScreen open={open} onClose={onClose}>
      <AppBar position="sticky">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2 }} variant="h6" component="div">
            {translate("AddAProject")}
          </Typography>
        </Toolbar>
      </AppBar>

      <Box
        sx={{
          p: 2,
          display: "flex",
          flexDirection: "column",
          height: "100%",
          boxSizing: "border-box",
        }}
      >
        <TextField
          label={translate("ProjectName")}
          placeholder={translate("ProjectName")}
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <Autocomplete
          multiple
          options={companyUsers}
          getOptionLabel={(u) => u.name || u.email}
          value={members}
          onChange={(_, v) => setMembers(v)}
          renderTags={(tags, getTagProps) =>
            tags.map((u, i) => (
              <Chip
                {...getTagProps({ index: i })}
                key={u.id}
                label={u.name || u.email}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label={translate("ProjectMembers")}
              placeholder={translate("ProjectMembers")}
            />
          )}
          sx={{ mt: 2 }}
        />

        <Box sx={{ flexGrow: 1 }} />

        <Button
          variant="contained"
          fullWidth
          size="large"
          onClick={onConfirm}
          disabled={!name.trim() || saving}
        >
          {saving ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            translate("Create")
          )}
        </Button>
        <Button onClick={onClose} sx={{ mt: 1 }}>
          {translate("Cancel")}
        </Button>
      </Box>
    </Dialog>
  );
}
